/**
 * @generated SignedSource<<043ddec6014c39f3eb8a5b27fa49c14c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnitSchoolGradeEnum = "five" | "four" | "high" | "highest" | "low" | "lowest" | "medium" | "one" | "seven" | "six" | "three" | "two" | "zero" | "%future added value";
export type TaskMigrateInput = {
  difficultyGrade?: UnitSchoolGradeEnum | null;
  id: string;
  unitDs: ReadonlyArray<string>;
};
export type TaskMigrateDialog_taskMigrateMutation$variables = {
  input: TaskMigrateInput;
};
export type TaskMigrateDialog_taskMigrateMutation$data = {
  readonly taskMigrate: {
    readonly id: string;
  };
};
export type TaskMigrateDialog_taskMigrateMutation = {
  response: TaskMigrateDialog_taskMigrateMutation$data;
  variables: TaskMigrateDialog_taskMigrateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "taskMigrate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskMigrateDialog_taskMigrateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskMigrateDialog_taskMigrateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a08f24a85c833982ac61a4322f11744b",
    "id": null,
    "metadata": {},
    "name": "TaskMigrateDialog_taskMigrateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskMigrateDialog_taskMigrateMutation(\n  $input: TaskMigrateInput!\n) {\n  taskMigrate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "33c5cd1efc7de5cecd472b964c5ed9f0";

export default node;
